export enum ExchangeAddressField {
  COUNTRY = "country",
  PROVINCE = "province",
  CITY = "city",
  POSTAL_CODE = "postalCode",
  STREET = "street",
}

const exchangeAddressFields: ReadonlySet<string> = new Set(
  Object.values(ExchangeAddressField),
);

function isExchangeAddressField(value: string): value is ExchangeAddressField {
  return exchangeAddressFields.has(value);
}

/** Nothing stored locks the country; only an explicit empty list unlocks. */
export function getExchangeAddressLockedFields(
  returnEditing:
    | { exchangeAddressLockedFields?: readonly string[] | null }
    | null
    | undefined,
): ExchangeAddressField[] {
  const stored = returnEditing?.exchangeAddressLockedFields;
  if (!stored) {
    return [ExchangeAddressField.COUNTRY];
  }
  return stored.filter(isExchangeAddressField);
}
